import { render, staticRenderFns } from "./TabSupplementComponent.vue?vue&type=template&id=071e805a&scoped=true"
import script from "./TabSupplementComponent.vue?vue&type=script&lang=js"
export * from "./TabSupplementComponent.vue?vue&type=script&lang=js"
import style0 from "./TabSupplementComponent.vue?vue&type=style&index=0&id=071e805a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071e805a",
  null
  
)

export default component.exports